import { createSelector } from "reselect";

import { getZendeskConfigSelector, makeSelectRoutePathname } from "../../app/appSelectors";
import { PAGES_ZENDESK_FIXED_BUTTON_IS_VISIBLE } from "./zendeskConstants";

export const getZendeskSnippetKeySelector =
    createSelector(getZendeskConfigSelector, config => config.snippetKey);

export const getIsZendeskInitedSelector =
    createSelector(getZendeskConfigSelector, config => config.isInited);

export const getZendeskTokenSelector =
    createSelector(getZendeskConfigSelector, config => config.token);

export const getZendeskWidgetTypeSelector =
    createSelector(getZendeskConfigSelector, config => config.widgetType);

export const getZendeskUnreadMessagesCountSelector =
    createSelector(getZendeskConfigSelector, config => config.unreadMessagesCount);

export const getIsZendeskFixedButtonVisibleSelector =
    createSelector([makeSelectRoutePathname()], (pathname) =>
        PAGES_ZENDESK_FIXED_BUTTON_IS_VISIBLE.includes(pathname as any)
    );
